"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactSpring = require("react-spring");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    // background color declaration in JSX only!!\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    border-radius: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Ripple = (0, _reactSpring.animated)(_styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.rippleBorderRadius;
}));
var _default = Ripple;
exports["default"] = _default;